import { render, staticRenderFns } from "./SMSOnboardingWizard.vue?vue&type=template&id=068f394c&scoped=true"
import script from "./SMSOnboardingWizard.vue?vue&type=script&lang=js"
export * from "./SMSOnboardingWizard.vue?vue&type=script&lang=js"
import style0 from "./SMSOnboardingWizard.vue?vue&type=style&index=0&id=068f394c&prod&lang=scss&scoped=true"
import style1 from "./SMSOnboardingWizard.vue?vue&type=style&index=1&id=068f394c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068f394c",
  null
  
)

export default component.exports